// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var RtlFastStatsReportSettingsController = function ($scope, RtlFastStatsReportSettingsSettings) {
    $scope.settingsLoaded = false;

     RtlFastStatsReportSettingsSettings.get().$promise.then(function (response) {
        $scope.rtlFastStatsReportSettings = response;
        $scope.settingsLoaded = true;
    });

    $scope.save = function () {
        $scope.rtlFastStatsReportSettings.$update({}, function (data) {
            if (data && data.IsValid) {
                $scope.notifySuccess();
            } else {
                $scope.notifyValidationError();
            }
        });
    };
};

RtlFastStatsReportSettingsController.$inject = ['$scope', 'RtlFastStatsReportSettings'];
